import React from 'react';
import LegalLayout, { LegalH2, LegalP, LegalUl } from './LegalLayout';

const AvisoLegal = () => (
  <LegalLayout
    title="Aviso legal"
    subtitle="Información sobre el titular de este sitio web conforme al artículo 10 de la Ley 34/2002 de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE)."
    lastUpdate="Abril 2026"
  >
    <LegalH2 id="titular">1. Titular del sitio web</LegalH2>
    <LegalP>
      En cumplimiento de la LSSI-CE, se informa de los siguientes datos identificativos del titular:
    </LegalP>
    <LegalUl>
      <li><strong>Titular:</strong> Herminio Vázquez Vigón</li>
      <li><strong>Naturaleza:</strong> Autónomo persona física. El NIF se facilitará de forma privada ante solicitud fundada (reclamaciones formales, requerimientos administrativos o judiciales, facturación).</li>
      <li><strong>Actividad:</strong> Formación online y creación de contenidos digitales educativos.</li>
      <li><strong>Domicilio profesional:</strong> Barcelona (España).</li>
      <li><strong>Correo electrónico de contacto:</strong> <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a></li>
      <li><strong>Nombre comercial del proyecto:</strong> Escuela de Consciencia Akáshica.</li>
    </LegalUl>

    <LegalH2 id="objeto">2. Objeto</LegalH2>
    <LegalP>
      El presente Aviso Legal regula el uso del sitio web titularidad del responsable indicado (en adelante, "el Sitio"). El acceso y navegación por el Sitio implica la aceptación, sin reservas, de todas las disposiciones incluidas en este Aviso Legal, en la Política de Privacidad, en la Política de Cookies y, en su caso, en las Condiciones Generales de Contratación aplicables.
    </LegalP>

    <LegalH2 id="propiedad">3. Propiedad intelectual e industrial</LegalH2>
    <LegalP>
      Todos los contenidos del Sitio —textos, imágenes, fotografías, gráficos, logotipos, audios, vídeos, archivos descargables, estructura de navegación, bases de datos, diseños y código fuente— son titularidad del responsable o de terceros que han autorizado su uso, y se encuentran protegidos por la legislación española e internacional sobre propiedad intelectual e industrial.
    </LegalP>
    <LegalP>
      Queda expresamente prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otro acto de explotación de los contenidos del Sitio, total o parcial, sin autorización previa y por escrito del titular. El acceso al Sitio no confiere a la persona usuaria ningún derecho de propiedad sobre sus contenidos.
    </LegalP>

    <LegalH2 id="condiciones-uso">4. Condiciones de uso del Sitio</LegalH2>
    <LegalP>
      La persona usuaria se compromete a hacer un uso diligente, correcto y lícito del Sitio, y en particular se obliga a abstenerse de:
    </LegalP>
    <LegalUl>
      <li>Utilizar los contenidos con fines o efectos contrarios a la ley, la moral o el orden público.</li>
      <li>Reproducir, copiar, distribuir, transformar o modificar los contenidos sin autorización.</li>
      <li>Introducir virus, código malicioso o cualquier elemento que pueda dañar el Sitio o los sistemas de terceros.</li>
      <li>Intentar acceder a áreas restringidas sin autorización, o realizar ingeniería inversa sobre el Sitio.</li>
      <li>Suplantar la identidad de otra persona al registrarse o contratar servicios.</li>
    </LegalUl>

    <LegalH2 id="responsabilidad">5. Responsabilidad</LegalH2>
    <LegalP>
      El titular realiza los esfuerzos razonables para mantener el Sitio operativo y para que la información publicada sea exacta y actualizada, pero no garantiza la ausencia de errores, interrupciones, retrasos u omisiones en el acceso, ni la exactitud absoluta de los contenidos.
    </LegalP>
    <LegalP>
      En la medida permitida por la legislación aplicable, el titular no será responsable de los daños o perjuicios que puedan derivarse del uso del Sitio, de la imposibilidad temporal de acceso, de fallos técnicos, ni del uso indebido que terceros hagan de los contenidos. Lo anterior se entiende sin perjuicio de los derechos irrenunciables reconocidos a las personas consumidoras por la legislación vigente.
    </LegalP>

    <LegalH2 id="enlaces">6. Enlaces a terceros</LegalH2>
    <LegalP>
      El Sitio puede contener enlaces a páginas web de terceros (por ejemplo, redes sociales, proveedores de pago o plataformas de mensajería). El titular no controla esos sitios y no asume responsabilidad por sus contenidos, sus políticas de privacidad o por cualquier daño derivado de su uso. La inclusión de un enlace no implica recomendación ni asociación comercial.
    </LegalP>

    <LegalH2 id="modificaciones">7. Modificaciones</LegalH2>
    <LegalP>
      El titular se reserva el derecho a modificar, sin previo aviso, la información contenida en el Sitio, así como las presentes condiciones de uso y cualquier texto legal. Las modificaciones serán aplicables desde su publicación. Se recomienda revisar este Aviso Legal periódicamente.
    </LegalP>

    <LegalH2 id="ley">8. Legislación aplicable y jurisdicción</LegalH2>
    <LegalP>
      Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada del uso del Sitio, las partes se someten, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, a los Juzgados y Tribunales de Barcelona (España), salvo que la legislación de protección de las personas consumidoras disponga otro fuero con carácter imperativo.
    </LegalP>
    <LegalP>
      Si eres persona consumidora y resides en la Unión Europea, puedes acudir a la plataforma de resolución de litigios en línea de la Comisión Europea: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#c9a227] hover:underline">https://ec.europa.eu/consumers/odr</a>.
    </LegalP>
  </LegalLayout>
);

export default AvisoLegal;
